
import merge from 'webpack-merge'
import store from '../../store/store'
//固定变量
export const page=1;
export const rows=10;

//===================时间操作===================
/**
 * [时间差]
 * @param {[str]} 需要比较的时间
 */
export function timeDiff_now(str){
	let result="";
	if(str){
		let time = new Date(str).getTime();//日期字符串转时间戳
		if(isAllNum(time)){
			let timestamp=new Date().getTime();//当前时间
			if(timestamp>time){
				let diff=timestamp-time;
				let day=Math.floor(diff/(1000*60*60*24));//天
				let hour=Math.floor((diff-day*24*60*60*1000)/(1000*60*60));//小时
				let minute=Math.floor((diff-day*24*60*60*1000-hour*60*60*1000)/(1000*60));//分
				result=day+"天"+hour+"小时"+minute+"分";
			}
		}
	}
	return result;
}

/**
 * [时间戳转化为字符串]
 * @param {[num]} 时间戳
 */
export function time_numToStr(num){
	try {
		let d = new Date(num);    //根据时间戳生成的时间对象
		let date = (d.getFullYear()) + "-" +
				(d.getMonth() + 1) + "-" +
				(d.getDate()) + " " +
				(d.getHours()) + ":" +
				(d.getMinutes()) + ":" +
				(d.getSeconds());
		return date;
	} catch (error) {
		console.log("传入参数不为时间戳");
	}
	return "";
}

//时间格式化，传入type(true),为年月日 时分秒，不传或者false为年月日
export function myTimeToLocal(inputTime, type) {
  if (!inputTime && typeof inputTime !== 'number') {
    return '';
  }
  var localTime = '';
  inputTime = new Date(inputTime).getTime();
  const offset = (new Date()).getTimezoneOffset();
  localTime = (new Date(inputTime - offset * 60000)).toISOString();
  localTime = localTime.substr(0, localTime.lastIndexOf('.'));
  if (type) {
    localTime = localTime.replace('T', '  ');
    return localTime;
  }
  return localTime.slice(0, localTime.lastIndexOf('T'))
}

//===================时间操作===================

//===================其他===================
/**
 * [是否全为数字]
 * @param {[str]}
 */
export function isAllNum(str){
	if(/^[0-9]+$/.test(str)){//这是用正则表达是检查
		return true;
	}else{
		return false;
	}
}

/**
 * 去除参数空数据
 * @param {Object} obj [参数对象]
 */
export let filterEmptyData = (obj) => {
    for (let prop in obj) {
        obj[prop] === '' ? delete obj[prop] : obj[prop]
    }
    return obj
}

/*
* 验证手机号是否合格
* true--说明合格
*/
export function isPhone (phoneStr){
	let myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
	if (!myreg.test(phoneStr)) {
		return false;
	} else {
		return true;
	}
}

/*
* 生日转为年龄
* true--说明合格
*/
export function birsdayToAge (birsday) {
	let aDate = new Date();
	let thisYear = aDate.getFullYear();
	let bDate = new Date(birsday);
	let brith = bDate.getFullYear();
	let age = (thisYear - brith);
	return age
}

/*
* 保留两位小数(注意：小数值为0的情况只返回整数部分，如：30.00  30.0001都返回30)
*/
export function numShow (num) {
   try {
		let num_tem=num.toFixed(2);
		let num_tem2=Math.floor(num);
		if(num_tem>num_tem2){
			return num_tem;
		}else{
			return num_tem2;
		}
   } catch (error) {
		return num;
   }
}

/*
* 是否数组
*/
export function isArray (val) {
	if(val&&val instanceof Array){
		return true;
	}else{
		return false;
	}
 }

 /*
* 是否空数组
*/
export function isArrayEmpty (val) {
	if(val&&val instanceof Array&&val.length>0){
		return false;
	}else{
		return true;
	}
 }

   /*
* 是否空对象
*/
export function isObjectEmpty (val) {
	if(val&&val instanceof Object){
		for (let item in val) {
			return false;
		}
		return true;
	}else{
		return true;
	}
 }

 
 /**
 * [是否不为空：包括：undefined  空格  多个空格]
 * @param {[str]}
 */
export function isNoNullAll(str){
	if(str===0||(str&&String(str).trim())){//这是用正则表达是检查
		return true;
	}else{
		return false;
	}
}

 // 格式化日期，如月、日、时、分、秒保证为2位数
function formatNumber (n) {
    n = n.toString()
    return n[1] ? n : '0' + n;
}

 /**
 * 时间戳转化为时间字符串
 * @param {*} number
 * @param {*} format    'Y-M-D h:m:s'   'Y年M月D日 h:m:s'
 */
export function formatTime (number, format) {
    let time = new Date(number)
    let newArr = []
    let formatArr = ['Y', 'M', 'D', 'h', 'm', 's']
    newArr.push(time.getFullYear())
    newArr.push(formatNumber(time.getMonth() + 1))
    newArr.push(formatNumber(time.getDate()))

    newArr.push(formatNumber(time.getHours()))
    newArr.push(formatNumber(time.getMinutes()))
    newArr.push(formatNumber(time.getSeconds()))

    for (let i in newArr) {
        format = format.replace(formatArr[i], newArr[i])
    }
    return format;
}
//==================其他（培训）====================

//===================获取sessionStorage的值===============
//获取当前选中菜单的值
export function getInfo(){
  // console.log( JSON.parse(sessionStorage.getItem('info')))
  return JSON.parse(sessionStorage.getItem('info'))
}
//获取当前培训id
export function getPid(){
  return sessionStorage.getItem('pid')
}

//====================格式化时间=================
/**
 *
 * @param time 时间戳  - format 连接符
 */
export function customDate(time,format){
  let now = new Date(time)
  let year = now.getFullYear(),
    month = now.getMonth() + 1,
    date = now.getDate(),
    hour = now.getHours(),
    minute = now.getMinutes(),
    second = now.getSeconds();
  function p(s) {
    return s < 10 ? '0' + s: s;
  }
  return year + format + p(month) + format + p(date)+ " " + p(hour) + ":" + p(minute) + ":" + p(second);
}

//====================防挂机定时器工具=================

//倒计时时间格式化
export function formateTime(time){
  let arr = ['00','00','00'];
  arr[0] = parseInt(time/3600);
  arr[1] = parseInt(time%3600/60);
  arr[2] = parseInt(time%3600%60);
  if( arr[0] < 10 ){
    arr[0] = `0${arr[0]}`
  }else if(arr[0] >= 24){
    return `${ parseInt(arr[0]/24) } 天`
  }
  if( arr[1] < 10){
    arr[1] = `0${arr[1]}`
  }
  if( arr[2] < 10 ){
    arr[2] = `0${arr[2]}`
  }
  return arr.join(':');
};

//===================计算学习时间工具===============


//开始记录学习时长
export function beginStudy(){
  localStorage.setItem('studyBtime',JSON.parse(Date.parse(new Date())))
}

//结束记录学习时长
export function endStudy(){
  localStorage.setItem('studyEtime',JSON.parse(Date.parse(new Date())))
}

//计算学习时间
export function studyTime(){
  if(localStorage.getItem('studyEtime') && localStorage.getItem('studyBtime')){
    return (Number(localStorage.getItem('studyEtime')) - localStorage.getItem('studyBtime'))/1000;
  }
}

//===================学习课件类型===============
export function lessonTypeUrl(type) {
  if(type == undefined){
    return '/test'
  }
  switch (type) {
    case 1 :
    case 2 :
      if(getInfo().attchList){
        let attch = getInfo().attchList;
        if(attch.length){
          if(attch[0].ext == '.txt' || attch[0].ext == '.doc' || attch[0].ext == '.docx' || attch[0].ext == '.pdf' || attch[0].ext == '.ppt' || attch[0].ext == '.pptx'){
            return '/documentDetails'
          }else if(attch[0].ext == '.mp4'){
            return '/videoDetails'
          }
          else if(attch[0].ext == '.jpg' || attch[0].ext == '.png' || attch[0].ext == '.jpeg'){
            return '/picture'
          }else{
            return '/404'
          }
        }else{
          return '/404'
        }
      }else{

        return '/404'
      }
      break;
    case 3:
      return "/examtip"
      break;
  }
}
export function lessonTypeUrlManagement(type) {
  if(type === undefined){
    return '/management-test'
  }
  switch (type) {
    case 1 :
    case 2 :
      if(getInfo().attchList){
        let attch = getInfo().attchList;
        if(attch.length){
          if( attch[0].ext == '.txt' || attch[0].ext == ".doc" || attch[0].ext == '.docx' || attch[0].ext == '.pdf' || attch[0].ext == '.ppt' || attch[0].ext == '.pptx'){
            return '/management-documentDetails'
          }else if(attch[0].ext == '.mp4'){
            return '/management-videoDetails'
          }
          else if(attch[0].ext == '.jpg' || attch[0].ext == '.png' || attch[0].ext == '.jpeg'){
            return '/management-picture'
          }
        }else{
          return '/management-404'
        }
      }else{
        return '/management-404'
      }
      break;
    case 3:
      return "/management-exam"
      break;
  }
}
//===================考试-测验===============

//计算总分数
export function totalScore(arr){
  let total = 0;
  arr.map((item)=>{
    total += Number(item.score);
  })
  return total;
}

//记录考试数据
export function setExamInfo(examInfo){
  sessionStorage.setItem('examInfo',JSON.stringify(examInfo))
  // console.log(getExamInfo())
}

//读取考试数据
export function getExamInfo(){
  return JSON.parse(sessionStorage.getItem('examInfo'))
}

//记录考试详情数据
export function setExamDetail(examDetail){
  sessionStorage.setItem('examDetail',JSON.stringify(examDetail))
  // console.log(getExamInfo())
}

//读取考试详情数据
export function getExamDetail(){
  return JSON.parse(sessionStorage.getItem('examDetail'))
}

//比较两个数组是否相等
export function equar(a, b) {
  // 判断数组的长度
  if (a.length !== b.length) {
      return false
  } else {
    // 循环遍历数组的值进行比较
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
          return false
        }
    }
    return true;
  }
}

//将二维数组转换成一维数组
export function arrayConcat(arr) {
  let concatArr = [],
      arrCopy = [...arr];
  let leni = arrCopy.length-1;
  for(let i = leni ;i>=0;i--){
    if(!this.isArrayEmpty(arrCopy[i])){
      let lenj = arrCopy[i].length-1
      for(let j = lenj ;j>=0;j--){
        concatArr = concatArr.concat(arrCopy[i][j])
      }
    }
  }
  return concatArr;
}
//数组去重
export function arraySet(arr, key) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      if (arr[i][key] === arr[j][key]) {
        arr.splice(j, 1);
        j = j - 1;
      }
    }
  }
}


//判断数组中是否存在指定项 arr-比对数组 ；term-勾选数组 ；key-筛选字段
export function arrayExist(arr, term, key) {
  for(let i = 0; i < arr.length; i++){
    for (let j = 0; j < term.length; j++) {
      if (arr[i].id === term[j][key]) {
        // console.log('true')
        return true;
      }
    }
  }
  // console.log('false')
  return false;
}

////////////////////////////////////////////////////////页面通用方法////////////////////////////////////////////////////////
/**
 * 通过头部菜单添加路由参数和返回菜单id
 * @param {*} route this.$route
 * @param {*} router this.$router
 * @param {*} boolean 返回结果开关，默认不传返回找到的menuid，传true时返回找到的当前项
 */

function addRoutePathByHeadMenu_(list,route,router,b){//通过头部菜单添加路由参数和返回菜单id
  let result = undefined;
  // let list=store.state.app.headMenuTree;
  // return addmenuid(list,route,router);

  if (!isArrayEmpty(list) && route && route.path){
    // console.log("this.$route.path:",route.path);
    for (let index = 0; index < list.length; index++) {
      let path=list[index].jumpUrl;
      // console.log(path);
      if(path!=undefined&&path==route.path){
        router.push({
          query:merge(route.query,{'menuid':list[index].menuid})
        });
        // console.log(list[index].menuid);
        result = b ? list[index].parentMenuid ||"" : list[index].menuid;
      }else if(!isArrayEmpty(list[index].children)){
        result= addRoutePathByHeadMenu_(list[index].children, route, router);
      }
      if(result!=undefined){
        break;
      }
    }
  }
  return result;
}

/**
 * 通过头部菜单添加路由参数和返回菜单id
 * @param {*} route this.$route
 * @param {*} router this.$router
 */
export function addRoutePathByHeadMenu(route,router,b){//通过头部菜单添加路由参数和返回菜单id
  let menuid=route.query.menuid;
  if(menuid==undefined){
    let list = store.state.app.headMenuTree;
    menuid = addRoutePathByHeadMenu_(list,route,router,b);
  }
  return menuid;
}


//在线学习通用
/**
 * @param {*} data 学习列表数据
 * @param {*} baseUrl 地址前缀
 */
export function processData(data,baseUrl){
  if(!this.isArrayEmpty(data)){
    let dataCopy = [...data];
    dataCopy.forEach(item => {
      if(item.cover){
        item.cover = baseUrl + item.cover;
        item.linkUrl = `/online-learning/detail?pid=${item.id}`
      }
    });
  }
  return data
}

export function querySameData(arr,key,value) {
  return arr.find(item => {
    return item[key] == value;
  })
}

/*
 *  学校内容18 学校概况19 新闻20 党建活动21 风采22 教师风采23 学生风采24
 */
export function judeTypeId(typeid) {
  let breadCrumbList = [];
  switch (Number(typeid)) {
    case 18:
      breadCrumbList = [
        {
          path: '/agency-portal/school/school-portal',
          name: '学校内容'
        }
      ];
      break;
    case 19:
      breadCrumbList = [
        {
          path: '/agency-portal/school/school-details',
          name: '学校概况'
        }
      ];
      break;
    case 20:
      breadCrumbList = [
        {
          path: '/agency-portal/school/news-list',
          name: '新闻'
        },
        {
          // path: '/agency-portal/school/news-details',
          name: '新闻详情',
          hasContentid: true,
        }
      ];
      break;
    case 21:
      breadCrumbList = [
        {
          path: '/agency-portal/school/news-list',
          name: '党建活动'
        },
        {
          // path: '/agency-portal/school/news-details',
          name: '党建活动详情',
          hasContentid: true,
        }
      ];
      break;
    case 22:
      breadCrumbList = [
        {
          path: '/agency-portal/school/elegant-list',
          // detailPath: '/agency-portal/school/news-details',
          name: '风采'
        },
        {
          // path: '/agency-portal/school/news-details',
          name: '风采详情',
          hasContentid: true,
        }
      ];
      break;
    case 23:
      breadCrumbList = [
        {
          path: '/agency-portal/school/elegant-list',
          // detailPath: '/agency-portal/school/news-details',
          name: '教师风采'
        },
        {
          // path: '/agency-portal/school/news-details',
          name: '教师风采详情',
          hasContentid: true,
        }
      ];
      break;
    case 24:
      breadCrumbList = [
        {
          path: '/agency-portal/school/elegant-list',
          // detailPath: '/agency-portal/school/news-details',
          name: '学生风采'
        },
        {
          // path: '/agency-portal/school/news-details',
          name: '学生风采详情',
          hasContentid: true,
        }
      ];
      break;
    default:
      breadCrumbList = [];
  }
  // console.log(breadCrumbList)
  return breadCrumbList;
}

/**
 * 格式菜单，针对管理平台的权限
 * @param {*} list 
 * @param {*} userInfo 
 */
 function formerMenu_(list,userInfo){//格式菜单，针对管理平台的权限
  let num=0;
  if(!isArrayEmpty(list)){
    for (let index = 0; index < list.length; index++) {
      let element = list[index];
      if(element.menuid=="34"){//管理后台
        if(!isObjectEmpty(userInfo)&&(userInfo.manageType==0 || userInfo.manageType==1)){
          element.isNoSHow=false;//是否不展示
        }else{
          element.isNoSHow=true;//是否不展示
          num++;
        }
      }

      if(element.menuid=="35"){//教学大数据
        if(!isObjectEmpty(userInfo)&&(userInfo.manageType==0 || userInfo.bigData==1)){
          element.isNoSHow=false;//是否不展示
        }else{
          element.isNoSHow=true;//是否不展示
          num++;
        }
      }
    }
  }
  return num;
}
/**
 * 格式菜单，针对管理平台的权限
 * @param {*} list    菜单
 * @param {*} userInfo  用户信息
 */
 export function formerMenu(list,userInfo){//格式菜单，针对管理平台的权限
  if(!isArrayEmpty(list)){
    for (let index = 0; index < list.length; index++) {
      let element = list[index];
      if(element.menuid=="33"&&!isArrayEmpty(element.children)){//管理平台
        let num=formerMenu_(element.children,userInfo);
        if(num==element.children.length){
          element.isNoSHow=true;//是否不展示
        }else{
          element.isNoSHow=false;//是否不展示
        }
      }
    }
  }
}

////////////////////////////////////////////////////////页面通用方法////////////////////////////////////////////////////////
